import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getAirlinesInput,
  getAirlineInput,
  AirlineLiteModel,
  AirlineModel,
} from './model';

export function useGetAirlines(
  input?: getAirlinesInput,
  options?: UseQueryOptions<ExtendedApiResult<AirlineLiteModel[]>, ApiError>,
): UseQueryResult<ExtendedApiResult<AirlineLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getAirlines', input?.params],
      () =>
        QueryFetchFunction({
          url: 'airlines',
          params: input?.params,
        }),
      options,
    ),
    AirlineLiteModel,
  );
}

export function useGetAirline(
  input?: getAirlineInput,
  options?: UseQueryOptions<ApiResult<AirlineModel>, ApiError>,
): UseQueryResult<ApiResult<AirlineModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getAirline', input?.id],
      () => QueryFetchFunction({ url: `airlines/${input?.id}` }),
      options,
    ),
    AirlineModel,
  );
}

export function getAirlinesKey(input?: getAirlinesInput) {
  return ['getAirlines', input?.params];
}

export function getAirlineKey(input?: getAirlineInput) {
  return ['getAirline', input?.id];
}
